import {VEHICLE_B, VEHICLE_C, VEHICLE_NOTAG} from '../informo.const';
import {BaseLayerMVTDeck} from '../../../common/layers/baseLayerMVTDeck';
import {LAYERS_ID, LAYERS_SQL} from './constants';
import {hexToRgba} from '../../../common/utils';
import {GeoJsonLayer} from '@deck.gl/layers';
import {OnInit} from '@angular/core';
import {MvtService} from '../../../common/services/mvt.service';

export class PlatesRestrictionLayer extends BaseLayerMVTDeck implements OnInit {
    restrictionsLevel = 0;

    layers = {
        [LAYERS_ID.PLATES_RESTRICTION_INFORMO_LAYER]: (
            new GeoJsonLayer({
                id: LAYERS_ID.PLATES_RESTRICTION_INFORMO_LAYER,
                getLineColor: (f) => this.getLayerLineColor(f.properties),
                getFillColor: (f) => this.getLayerFillColor(f.properties),
                getLineWidth: 1,
                lineWidthMinPixels: 1,
                updateTriggers: {
                    getFillColor: this.restrictionsLevel,
                    getLineColor: this.restrictionsLevel,
                }
            })
        ),
    };

    constructor(private mvtService: MvtService) {
        super(LAYERS_ID.PLATES_RESTRICTION_INFORMO_LAYER);
    }

    ngOnInit(): void {
        this.restrictionsLevel = 0;
    }


    getLayerLineColor(properties) {
      const color = Number(properties.cartodb_id) >= this.restrictionsLevel ? '#F24F29' : '#2a2a2a';
      return hexToRgba(color);
    }

    getLayerFillColor(properties) {
      const opacity = Number(properties.cartodb_id) >= this.restrictionsLevel ? 14 : 0;
      return hexToRgba('#F24F29', opacity);
    }

    getDataLayer() {
        const p = [];
        Object.keys(this.layers).forEach(layer_id => {
            const tiles = this.mvtService.getMVT(
                layer_id,
                LAYERS_SQL[layer_id]()
            );

            p.push(tiles);
        });

        return Promise.all(p).then(values => {
            return Object.keys(this.layers).map((id, idx) => ({
                id,
                tiles: values[idx]
            }));
        });
    }

    setLayerFilters({plateType, alertLevel} = {plateType: null, alertLevel: null}) {
        this.restrictionsLevel = 5;
        if (plateType === VEHICLE_B && alertLevel < 4) {
          this.restrictionsLevel = 4;
        } else if (plateType === VEHICLE_B && alertLevel === 4) {
          this.restrictionsLevel = 3;
        } else if ((plateType === VEHICLE_B || plateType === VEHICLE_C) && alertLevel === 5) {
          this.restrictionsLevel = 3;
        } else if (plateType === VEHICLE_C && alertLevel < 5) {
          this.restrictionsLevel = 4;
        } else if (plateType === VEHICLE_NOTAG && alertLevel >= 3) {
          this.restrictionsLevel = 1;
        } else if (plateType === VEHICLE_NOTAG) {
          this.restrictionsLevel = 2;
        }
    }

    updateFilters({plateType, alertLevel}) {
        this.setLayerFilters({plateType, alertLevel});
        this.update(LAYERS_ID.PLATES_RESTRICTION_INFORMO_LAYER, {
            updateTriggers: {
                getFillColor: this.restrictionsLevel,
                getLineColor: this.restrictionsLevel
            }
        });
    }

    hide() {
        if (this.visible) {
            this.restrictionsLevel = 0;
            this.updateAll({
                visible: false,
                updateTriggers: {
                    getFillColor: this.restrictionsLevel,
                    getLineColor: this.restrictionsLevel
                }
            });
            this.visible = false;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/cities/informo/layers/platesRestrictionLayer.ts